
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import {
  Chart,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartSeriesLabels,
} from "@progress/kendo-react-charts";
import { useLocalization } from "@progress/kendo-react-intl";
import axios from "axios";
import { useState, useEffect } from "react";
import { AccessToken } from "../../config/AccessToken";
import { loadingPanel } from "../LoadingPanel";

export const RegularTag = () => {

  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [error, setError] = useState('');
  const [instance, accessTokenRequest] = AccessToken();
  const localizationService = useLocalization();
  let languageId = localStorage.getItem('languageId');
  const [loading, setLoading] = useState(false);

  const [devicesInfo, setDevicesInfo] = useState<any>(null);

  const getDeviceList = async (flag: boolean) => {

    setLoading(true);

    const commonOperations = (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
      axios.get(`${SERVER_URL}/device/active`, {
        headers,
        params: {
          enabled: flag
        }
      })
        .then((res) => {
          const data: any = res?.data
          let infoDevices: any = data?.data
          setDevicesInfo(infoDevices);
          setLoading(false);
        }).catch((data) => {
          setError(data?.message);
          setLoading(false);
        });
    }

    if (localStorage.getItem('accessToken') != null) {
      let accessToken = localStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.setActiveAccount(accessTokenRequest.account);
      await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
        // Acquire token silent success
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken);
      })
        .catch((error: any) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
          console.log(error);
          setLoading(false);
        });
    }
  }

  useEffect(() => {
    getDeviceList(true)
  }, [])

  const convertDDMMYYYYHHMMSStoISO = (dateString:any) =>{
    // 1. Split the string into date and time parts
    const [datePart, timePart] = dateString.split(' ');
  
    // 2. Split the date part into day, month, and year
    const [day, month, year] = datePart.split('/');
  
    // 3. Split the time part into hours, minutes, and seconds
    const [hours, minutes, seconds] = timePart.split(':');
  
    // 4. Create a new Date object.  Important: Months are 0-indexed!
    const date = new Date(year, month - 1, day, hours, minutes, seconds);
  
    // 5. Convert to ISO string
    const isoString = date.toISOString();
  
    return isoString;
  }

  const regularTag:any = localStorage.getItem('regularTag')
  let currRegularTag: any = 0

  const now = new Date()
  const actualDate:any = new Date(now.getTime() - regularTag * 60 * 60 * 1000); // Subtract hours

  const dateFormatted:any = actualDate.toISOString()

  devicesInfo?.forEach((device: any) => {
    if(device.dateTime != null){

      const converted:any = convertDDMMYYYYHHMMSStoISO(device.dateTime)

      if( converted > dateFormatted){
        currRegularTag++
      }
    }
  });

  const totalDevices = devicesInfo?.length ?? 0;
  const otherDevices = Math.max(totalDevices - currRegularTag, 0);
  const regularLabel = localizationService.toLanguageString('dashboard.widget.regular_tag', 'NOT_FOUND');
  const otherLabel = languageId == 'it-IT' ? 'Altri' : 'Other';

  const regularTagsData = [
    {
      deviceName: regularLabel,
      counterStatus: currRegularTag,
      colorField: '#0f7c8a'
    },
    {
      deviceName: otherLabel,
      counterStatus: otherDevices,
      colorField: '#9fb8c2'
    }
  ];

  const donutCenterRenderer = () => (
    <span style={{ fontSize: '10px' }}>
      <h3>{currRegularTag}/{totalDevices}</h3>
      {regularLabel}
      <br />
      ({localStorage.getItem('regularTag') ?? 5}H)
    </span>
  );

  const labelContent = (props: any) => {
    if (props.dataItem.counterStatus > 0) {
      return `${props.category}\n(${props.dataItem.counterStatus})`;
    }
    return '';
  };

return (
  <div style={{ containerType: 'inline-size' }}>
    {loading && loadingPanel}
    {totalDevices > 0 ? (
      <Chart donutCenterRender={donutCenterRenderer}>
        <ChartSeries>
          <ChartSeriesItem
            type="donut"
            data={regularTagsData}
            categoryField={'deviceName'}
            field={'counterStatus'}
            colorField="colorField"
            tooltip={{ visible: true }}
          >
            <ChartSeriesLabels
              distance={5}
              position="outsideEnd"
              font="0.8em var(--kendo-font-family, inherit)"
              visible={false}
              content={labelContent}
            />
          </ChartSeriesItem>
        </ChartSeries>
        <ChartLegend
          position="bottom"
          orientation="horizontal"
          labels={{ color: '#000000' }}
        />
      </Chart>
    ) : (
      <div style={{ textAlign: 'center', padding: '20px', border: '1px dashed #ccc' }}>
        <p>{localizationService.toLanguageString('dashboard.widget.devices_status.no_value', 'NOT_FOUND')}</p>
      </div>
    )}
    {error && (
      <p style={{ color: '#b42318', fontSize: 12, marginTop: 6 }}>{error}</p>
    )}
    </div>
  
);
};